import { TextField } from '@mui/material';
import { ListFilterSelectWrapLine } from './common';
import { useDebounceCallback } from 'usehooks-ts';
import { useState } from 'react';

interface ListFilterSelectSearchProps {
  value?: string;
  onSearch: (value: string) => void;
  searchPlaceholder?: string;
  disabled?: boolean;
  debounceTime?: number;
}

export default function ListFilterSelectSearch({
  value,
  onSearch,
  searchPlaceholder,
  disabled,
  debounceTime = 250,
}: ListFilterSelectSearchProps) {
  const [searchInput, setSearchInput] = useState<string>(value || '');
  const debounced = useDebounceCallback(onSearch, debounceTime);

  const handleOnChange = (searchValue: string) => {
    setSearchInput(searchValue);
    debounced(searchValue);
  };

  return (
    <ListFilterSelectWrapLine>
      <TextField
        size="small"
        onChange={(e) => handleOnChange(e.target.value)}
        autoFocus
        fullWidth
        type="search"
        value={searchInput}
        placeholder={searchPlaceholder ?? 'Search...'}
        disabled={disabled}
        data-testid="list-filter-select-search"
      />
    </ListFilterSelectWrapLine>
  );
}
